// import React, { useContext, useEffect, useRef, useState } from "react";
// import { Form } from "react-router-dom";
// import Function from "../../../StateContext/Application";
// import {
//   Cancel32,
//   Email32,
//   PhoneNumber32,
//   submit,
// } from "../../../../../public/LoginImages/importimages";
// import Select from "react-select";
 
// const CreateEmployee = () => {
//   const types = useContext(Function);
//   const { EmployeeManagement, Roles, DepartmentHandler } = types;
//   const [EmployeeList, SetEmployeeList] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [emailError, setEmailError] = useState(""); //28-09
//   const [formData, setFormData] = useState({
//     FullName: "",
//     ProfilePic: "",
//     PhoneNumber: "",
//     Email: "",
//     Password: "",
//     RoleID: "",
//     Role: "",
//     Department_ID: "",
//     Department_Name: "",
//     Username: "",
//         MakerUsername: "", //28-09

//   });

//   const [Role, SetRole] = useState([]);
//   const [optionrole, SelectedRole] = useState();
//   const [DepartmentList, SetDepartment] = useState([]);
//   const [FilteredDepartment, SetFilteredDepartment] = useState([]);
//   const formdataref = useRef(null);
//     const [StateMakers, SetStateMakers] = useState([]);//28-09
//   const [showPassword, setShowPassword] = useState(false);
//   useEffect(() => {
//     getData();
//   }, []);
//   // const getData = async () => {
//   //   try {
//   //     let data = await Roles("View", null);
//   //     SetRole(data);
//   //     let department = await DepartmentHandler("view", null, null);
//   //     SetDepartment(department);
//   //   } catch (error) {
//   //     console.error(error);
//   //   }
//   // };
//   const getData = async () => {
//     try {
//       let data = await Roles("View", null);
//       SetRole(data);
//       let department = await DepartmentHandler("view", null, null);
//       console.log("ALL DEPARTMENT =>", department);

//       let user =
//         JSON.parse(localStorage.getItem("User")) ||
//         JSON.parse(localStorage.getItem("user"));
//       console.log("LOGIN USER =>", user);
//       // let filteredDepartment = [];

//       //     const role = user?.Role?.trim();
//       // const dept = user?.Department_Name?.trim();
//       // console.log(role)
//       // console.log(dept)
//       // if (role?.includes("state")) {
//       //   filteredDepartment = department.filter(
//       //     e =>
//       //       e.Department_Name === "State Maker" ||
//       //       e.Department_Name === "State Checker"
//       //   );
//       // } else if (role?.includes("agency admin")) {
//       //   filteredDepartment = department.filter(
//       //     e =>
//       //       e.Department_Name === "Agency Maker" ||
//       //       e.Department_Name === "Agency Checker"
//       //   );
//       // } else if (role?.includes("New Agency Admin")) {
//       //   filteredDepartment = department.filter(

//       //     e =>
//       //       e.Department_Name === "New Agency Maker" ||
//       //       e.Department_Name === "New Agency Checker"
//       //   );
//       //   console.log(filteredDepartment)
//       // }
//       // else if (
//       //   dept === "agency maker" ||
//       //   dept === "agency checker"
//       // ) {
//       //   filteredDepartment = department.filter(
//       //     e =>
//       //       e.Department_Name === "New Agency Maker" ||
//       //       e.Department_Name === "New Agency Checker"
//       //   );
//       // }

//       //       console.log("FILTERED DEPARTMENT =>", filteredDepartment);

//       //       SetDepartment(filteredDepartment);
//       const role = user?.Role?.trim().toLowerCase();
//       const dept = user?.Department_Name?.trim().toLowerCase();

//       let filteredDepartment = [];

//       // if (role.includes("state")) {
//       //   filteredDepartment = department.filter(
//       //     (e) =>
//       //       e.Department_Name === "State Maker" ||
//       //       e.Department_Name === "State Checker",
//       //   );
//       // } else if (role.includes("agency admin")) {
//       //   filteredDepartment = department.filter(
//       //     (e) =>
//       //       e.Department_Name === "Agency Maker" ||
//       //       e.Department_Name === "Agency Checker",
//       //   );
//       // } else if (role.includes("new agency admin")) {
//       //   filteredDepartment = department.filter(
//       //     (e) =>
//       //       e.Department_Name === "New Agency Maker" ||
//       //       e.Department_Name === "New Agency Checker",
//       //   );
//       // } else if (dept === "agency maker" || dept === "agency checker") {
//       //   filteredDepartment = department.filter(
//       //     (e) =>
//       //       e.Department_Name === "New Agency Maker" ||
//       //       e.Department_Name === "New Agency Checker",
//       //   );
//       // } else {
//       //   // fallback
//       //   filteredDepartment = department;
//       // }


//       // 22-09 depart fetch change for user type
//       if (role.includes("state")) {
//   filteredDepartment = department.filter(
//     (e) =>
//       e.Department_Name === "State Maker" ||
//       e.Department_Name === "State Checker",
//   );
// } else if (role.includes("new agency admin")) {   // ← moved up
//   filteredDepartment = department.filter(
//     (e) =>
//       e.Department_Name === "New Agency Maker" ||
//       e.Department_Name === "New Agency Checker",
//   );
// } else if (role.includes("agency admin")) {        // ← moved down
//   filteredDepartment = department.filter(
//     (e) =>
//       e.Department_Name === "Agency Maker" ||
//       e.Department_Name === "Agency Checker",
//   );
// } else if (dept === "agency maker" || dept === "agency checker") {
//   filteredDepartment = department.filter(
//     (e) =>
//       e.Department_Name === "New Agency Maker" ||
//       e.Department_Name === "New Agency Checker",
//   );
// } else {
//   filteredDepartment = department;
// }

//       SetDepartment(filteredDepartment);
//       console.log("LOGIN USER =>", user);
//       console.log("ROLE =>", user?.Role);
//       console.log("DEPARTMENT =>", user?.Department_Name);
//       console.log("ALL DEPARTMENT =>", department);
//       console.log("FILTERED DEPARTMENT =>", filteredDepartment);
//       let employees = await EmployeeManagement("View", null);
//  // 28-09
//       const empList = employees || [];
// SetEmployeeList(empList);
// SetStateMakers(
//   empList.filter((emp) => emp.Department_Name === "State Maker")
// );
//       // SetEmployeeList(employees || []);
//     } catch (error) {
//       console.error("Get Data Error =>", error);
//     }
//   };

//   const isEmailTaken = (email) =>
//     EmployeeList.some(
//       (emp) => emp.Email?.trim().toLowerCase() === email.trim().toLowerCase(),
//     );

//      // 23-09
//   const isUsernameTaken = (username) =>
//     EmployeeList.some(
//       (emp) => emp.Username?.trim().toLowerCase() === username.trim().toLowerCase(),
//     );

//   const handleChange = async (e) => {
//     try {
//       if (e.target.id === "Department_Name") {
//         let obj = JSON.parse(e.target.value);
//         SelectedRole(obj.Department_ID);
//         formData.Department_Name = obj.Department_Name;
//         formData.Department_ID = obj.Department_ID;
//            // 28-09
//          if (obj.Department_Name !== "State Checker") {
//     formData.MakerUsername = "";
//   }
//       } else if (e.target.id === "Role") {
//         let obj = JSON.parse(e.target.value);
//         formData.Role = obj.Designation;
//         formData.RoleID = obj.RoleID;
//       }
      
//       // else {
//       //   const { name, value } = e.target;
//       //   setFormData({ ...formData, [name]: value });
//       // }
//       // 28-09
//        else {
//   const { name, value } = e.target;
 
//   if (name === "Email") {
//     setFormData({ ...formData, Email: value });
 
//     // Correct email format check
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
//     if (value.length > 0 && !emailRegex.test(value)) {
//       setEmailError("Please enter a correct email address.");
//       return;
//     }
 
//     // Duplicate email check
//     if (value.length > 0 && isEmailTaken(value)) {
//       setEmailError("This email is already in use.");
//       alert("This email is already in use.");
//       return;
//     }
 
//     setEmailError("");
//   } else {
//     setFormData({ ...formData, [name]: value });
//   }
// }



      
//     } catch (error) {
//       console.error(error);
//     }
//   };

// //   const Submit = async (e) => {
// //     e.preventDefault();
// //     try {
// //       if (isEmailTaken(formData.Email)) {
// //         alert(
// //           "This email is already registered. Please use a different email.",
// //         );
// //         return;
// //       }
// //       // let data = await EmployeeManagement("Create", formData);
// //       // if (data === true) {
// //       //   alert("Employee Created Successfully");
// //       //   window.location.reload();
// //       // } else {
// //       //   alert("Employee Not Created");
// //       //   window.location.reload();
// //       // }
// //        // 23-09
// //       let data = await EmployeeManagement("Create", formData);
// // if (data === true) {
// //   alert("Employee Created Successfully");
// //   window.location.reload();
// // } else {
// //   alert("Employee Not Created");
// //   window.location.reload();
// // }
// //     } catch (error) {
// //       console.error(error);
// //     }
// //   };

// // 23-09
// //   const Submit = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);//28-09
// //     try {
// //       if (isEmailTaken(formData.Email)) {
// //         alert(
// //           "This email is already registered. Please use a different email.",
// //         );
// //         return;
// //       }

// //       // 23-09 — added username duplicate check alongside the email one
// //       if (isUsernameTaken(formData.Username)) {
// //         alert(
// //           "This username is already taken. Please choose a different username.",
// //         );
// //         return;
// //       }

// //       // let data = await EmployeeManagement("Create", formData);

// //       // Backend returns { success, message } — not a plain boolean —
// //       // so it can tell us *which* field collided (email or username).
// //       // if (data?.success) {
// //       //   alert("Employee Created Successfully");
// //       //   window.location.reload();
// //       // } else {
// //       //   alert(data?.message || "Employee Not Created");
// //       // }


// //       let data = await EmployeeManagement("Create", formData);

// // if (data === true) {
// //   alert("Employee Created Successfully");
// //   window.location.reload();
// // } else {
// //   alert("Employee Not Created");
// // }
// //     } catch (error) {
// //       console.error(error);
// //     }
// //     // 28-09
// //      finally {
// //     // Loader stop
// //     setLoading(false);
// //   }



// //   };



// // 05-10 chnage for validation to all filed
// const Submit = async (e) => {
//   e.preventDefault();

//   // Validate all mandatory fields
//   if (!formData.FullName?.trim()) {
//     alert("Please enter Full Name.");
//     return;
//   }

//   if (!formData.PhoneNumber?.trim()) {
//     alert("Please enter Phone Number.");
//     return;
//   }

//   if (formData.PhoneNumber.length !== 10) {
//     alert("Phone Number must be 10 digits.");
//     return;
//   }

//   if (!formData.Email?.trim()) {
//     alert("Please enter Email.");
//     return;
//   }

//   if (emailError) {
//     alert("Please enter a valid Email address.");
//     return;
//   }

//   if (!formData.Username?.trim()) {
//     alert("Please enter Username.");
//     return;
//   }

//   if (!formData.Password?.trim()) {
//     alert("Please enter Password.");
//     return;
//   }

//   if (!formData.Department_ID) {
//     alert("Please select User Type.");
//     return;
//   }

//   if (!formData.RoleID) {
//     alert("Please select Role.");
//     return;
//   }

//   // State Maker is mandatory only for State Checker
//   if (
//     formData.Department_Name === "State Checker" &&
//     !formData.MakerUsername
//   ) {
//     alert("Please select State Maker.");
//     return;
//   }

//   // Duplicate email check
//   if (isEmailTaken(formData.Email)) {
//     alert(
//       "This email is already registered. Please use a different email."
//     );
//     return;
//   }

//   // Duplicate username check
//   if (isUsernameTaken(formData.Username)) {
//     alert(
//       "This username is already taken. Please choose a different username."
//     );
//     return;
//   }

//   setLoading(true);

//   try {
//     const data = await EmployeeManagement("Create", formData);

//     if (data === true) {
//       alert("Employee Created Successfully");
//       window.location.reload();
//     } else {
//       alert("Employee Not Created");
//     }
//   } catch (error) {
//     console.error("Create Employee Error:", error);
//     alert("Something went wrong while creating the employee.");
//   } finally {
//     setLoading(false);
//   }
// };
// // // 01/10 for alert
// // const Submit = async (e) => {
// //   e.preventDefault();

// //   if (loading) return;

// //   setLoading(true);

// //   try {
// //     if (isEmailTaken(formData.Email)) {
// //       alert(
// //         "This email is already registered. Please use a different email."
// //       );
// //       return;
// //     }

// //     if (isUsernameTaken(formData.Username)) {
// //       alert(
// //         "This username is already taken. Please choose a different username."
// //       );
// //       return;
// //     }

// //     const data = await EmployeeManagement("Create", formData);

// //     console.log("Create Employee Response:", data);

// //     if (data?.success === true) {
// //       alert(data.message || "Employee Created Successfully");
// //       window.location.reload();
// //     } else {
// //       alert(data?.message || "Employee  Created"); //temporay
// //     }

// //   } catch (error) {
// //     console.error("Create Employee Error:", error);
// //     alert("Something went wrong while creating the employee.");
// //   } finally {
// //     setLoading(false);
// //   }
// // };
//   function PasswordManager(e) {
//     let input = e.currentTarget.parentNode.children[0];
//     let eye = e.currentTarget.parentNode.children[1];
//     input.type === "password"
//       ? (input.type = "text")
//       : (input.type = "password");

//     eye.className === "fa-regular fa-eye"
//       ? (eye.className = "fa-regular fa-eye-slash")
//       : (eye.className = "fa-regular fa-eye");
//   }
//   const resetData = () => {
//     formdataref.current.reset();
//     setFormData([]);
//   };
//   // return (
//   //   <div style={{ padding: '20px', backgroundColor: 'rgb(246, 248, 252)', maxLength: '94vh', overflowY: 'auto' }}>

//   //     <div >
//   //       <div >
//   //         <Form onSubmit={Submit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//   //           <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
//   //             <h5>Create Employee</h5>
//   //             <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//   //               <div style={{ display: 'grid' }} className="col-5">
//   //                 <label className='form-label' style={{ fontWeight: '700' }}>Full Name</label>
//   //                 <input
//   //                   type="text"
//   //                   className="form-control"
//   //                   name="FullName"
//   //                   value={formData.FullName}
//   //                   onChange={handleChange}
//   //                   required
//   //                   placeholder="Enter Full Name Here"
//   //                 />
//   //               </div>
//   //               <div style={{ display: 'grid' }} className="col-5">
//   //                 <label className="form-label" style={{ fontWeight: '700' }}>
//   //                   Phone Number
//   //                 </label>
//   //                 <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//   //                   <input type="tel" pattern="\d{10}" minLength="10" maxLength="10" className="form-control" name="PhoneNumber" value={formData.PhoneNumber} onChange={handleChange}
//   //                     onInput={(e) => {
//   //                       let enteredValue = e.target.value;
//   //                       enteredValue = enteredValue.slice(0, 10).replace(/\D/g, "");
//   //                       e.target.value = enteredValue;
//   //                     }}
//   //                     placeholder="Enter Phone Number Here"
//   //                     style={{ paddingRight: '35px' }} /><img src={PhoneNumber32} alt="Phone Icon" style={{ position: 'absolute', right: '10px', width: '20px', height: '20px' }} />
//   //                 </div>
//   //               </div>

//   //             </div>
//   //             <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//   //               <div style={{ display: 'grid' }} className="col-5">
//   //                 <label className='form-label' style={{ fontWeight: '700' }}>Email</label>
//   //                 <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//   //                   <input
//   //                     type="email"
//   //                     className="form-control"
//   //                     name="Email"
//   //                     value={formData.Email}
//   //                     onChange={handleChange}
//   //                     placeholder="Enter Email Here"
//   //                   /><img src={Email32} style={{ position: 'absolute', right: '10px', width: '20px', height: '20px' }} />
//   //                 </div>
//   //               </div>
//   //               <div style={{ display: 'grid' }} className="col-5">
//   //                 <label className="form-label" style={{ fontWeight: '700' }}>
//   //                   Password
//   //                 </label>
//   //                 <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//   //                   <input
//   //                     type="password"
//   //                     className="form-control"
//   //                     name="Password"
//   //                     value={formData.Password}
//   //                     onChange={handleChange}
//   //                     placeholder="Enter Password Here"
//   //                   />
//   //                   <i style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: '10px', cursor: 'pointer' }} className="fa-regular fa-eye" onClick={(e) => PasswordManager(e)}></i>
//   //                 </div>
//   //               </div>

//   //             </div>
//   //             <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//   //               <div style={{ display: 'grid' }} className="col-5">
//   //                 <label className='form-label' style={{ fontWeight: '700' }}>Select Department</label>

//   //                 <select
//   //                   className="form-control"
//   //                   id="Department_Name"
//   //                   onChange={(e) => handleChange(e)}
//   //                 >
//   //                   <option value={false}>Select Department</option>
//   //                   {DepartmentList.map((e) => {
//   //                     return (
//   //                       <option key={e.Department_ID} value={JSON.stringify(e)}>
//   //                         {e.Department_Name}
//   //                       </option>
//   //                     );
//   //                   })}
//   //                 </select>
//   //               </div>
//   //               <div style={{ display: 'grid' }} className="col-5">
//   //                 <label className='form-label' style={{ fontWeight: '700' }}>Role</label>

//   //                 <select
//   //                   className="form-control"
//   //                   id="Role"
//   //                   onChange={(e) => handleChange(e)}
//   //                 >
//   //                   <option value={false}>Selected Role</option>
//   //                   {Role.map((e) => {
//   //                     if (optionrole === e.Department_ID) {
//   //                       return (
//   //                         <option key={e.RoleID} value={JSON.stringify(e)}>
//   //                           {e.Designation}
//   //                         </option>
//   //                       );
//   //                     }
//   //                   })}
//   //                 </select>
//   //               </div>
//   //             </div>
//   //             <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '2.5rem' }}>
//   //               <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}><img src={submit} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} />Submit </button>
//   //               <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
//   //             </div>
//   //           </div>

//   //         </Form>
//   //       </div>
//   //     </div>
//   //   </div>
//   // );
//   return (
//     <div
//       style={{
//         padding: "20px",
//         backgroundColor: "white",
//         maxLength: "95vh",
//         minHeight: "95vh",
//         maxHeight: "95vh",
//         overflowY: "auto",
//       }}
//     >
//       <div>
//         {/* 29-09 add img */}
//          <h5 style={{fontSize:"20px", fontWeight:"700", marginLeft:'30px'}} ><img
//     src="/Create-Employee-32.png"
//     alt="img"
//    style={{height:"28px", width:"28px"}}
//   />
//  Create User</h5>
//         <div  style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "930px", margin: "0 auto" }}>
//           <Form
//             onSubmit={Submit}
//             ref={formdataref}
//                 //30/10
//            style={{
//   backgroundColor: "#EEF1F6",
//   borderRadius: "10px",
//   padding: "25px 28px",
// }}
//           >
//              {/* //30/10 */}
//             <div style={{ width: "100%" }}>
             

//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr",columnGap: "25px", marginBottom: "18px", }}>
//                 <div style={{ width:"100%"}}>
//                   <label className="form-label"  style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}}>  Full Name </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="FullName"
//                     value={formData.FullName}
//                     // onChange={(e) => {
//                     //   const value = e.target.value;
//                     //   if (/^[A-Za-z\s]*$/.test(value)) {
//                     //     handleChange(e);
//                     //   }
//                     // }}
//                     // 05-10 for validation
//                     onChange={(e) => {
//   const value = e.target.value;

//   if (/^[A-Za-z\s]*$/.test(value)) {
//     handleChange(e);
//   }
// }}
//                     required
//                     placeholder="Enter Full Name Here"
//                       style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} />
//                 </div>

//                 <div style={{ width:"100%"}}>
//                   <label className="form-label" style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}}>
//                     Phone Number
//                   </label>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       position: "relative",
//                     }}
//                   >
//                     {/* <input
//                       type="tel"
//                       pattern="\d{10}"
//                       minLength="10"
//                       maxLength="10"
//                       className="form-control"
//                       name="PhoneNumber"
//                       value={formData.PhoneNumber}
//                       onChange={handleChange}
//                       placeholder="Enter Phone Number Here"
//                       style={{ paddingRight: "35px" }}
//                     /> */}
//                     <input
//                       type="tel"
//                       className="form-control"
//                       name="PhoneNumber"
//                       value={formData.PhoneNumber}
//                       onChange={(e) => {
//                         const value = e.target.value
//                           .replace(/\D/g, "")
//                           .slice(0, 12);
//                         handleChange({
//                           target: {
//                             name: "PhoneNumber",
//                             value,
//                           },
//                         });
//                       }}
//                       placeholder="Enter Phone Number Here"
//                       maxLength={10}
//                       inputMode="numeric"
//                       style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }}                     />
//                     <img
//                       src={PhoneNumber32}
//                       alt="Phone Icon"
//                       style={{
//                         position: "absolute",
//                         right: "10px",
//                         width: "20px",
//                         height: "20px",
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns:"1fr 1fr",
//                   columnGap: "25px",
//                   marginBottom:"18px"
//                   // justifyContent: "space-evenly",
//                 }}
//               >
//                 <div style={{ width:"100%"}}>
//                   <label className="form-label" style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}}>
//                     Email
//                   </label>
//                   <div
//                     style={{
//                       // display: "flex",
//                       alignItems: "center",
//                       position: "relative",
//                     }}
//                   >
//                     <input
//                       type="email"
//                       className="form-control"
//                       name="Email"
//                       value={formData.Email}
//                       onChange={handleChange}
//                       required
//                       // onBlur={(e) => {
//                       //   if (isEmailTaken(e.target.value)) {
//                       //     alert("This email is already in use.");
//                       //   }
//                       // }}
//                       placeholder="Enter Email Here"
//                       style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} 
//                     />
       
                 
 
//                     <img
//                       src={Email32}
//                       style={{
//                         position: "absolute",
//                         right: "10px",
//                         width: "20px",
//                         height: "20px",
//                         top:"10px"
//                       }}
//                     />
//                                     {/* 28-09 */}
//                     {emailError && (
// <span

//     style={{

//       color: "red",

//       fontSize: "13px",

//       marginTop: "5px",

//     }}
// >

//     {emailError}
// </span>

// )}
                    
//                   </div>
//                 </div>

//                 <div style={{ width:"100%"}}>
//                   <label className="form-label" style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}}>
//                     Username
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="Username"
//                     value={formData.Username}
//                     onChange={handleChange}
//                     required
//                     placeholder="Enter Username Here"
//                     style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} 
//                   />
//                 </div>
//               </div>

//               <div
//                 style={{
//                   display: "flex",
//                   gap: "20px",
//                   justifyContent: "space-evenly",
//                 }}
//               >
//                 <div style={{ width:"100%"}}>
//                   <label className="form-label" style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}}>
//                     User Type
//                   </label>
//                   {/* <select
//                     className="form-control"
//                     id="Department_Name"
//                     onChange={handleChange}
//                   >
//                     <option value={false}>Select User Type</option>
//                     {DepartmentList.map((e) => (
//                       <option key={e.Department_ID} value={JSON.stringify(e)}>
//                         {e.Department_Name}
//                       </option>
//                     ))}
//                   </select> */}
//                   <Select
//       options={DepartmentList}
//       getOptionLabel={(e) => e.Department_Name}
//       getOptionValue={(e) => String(e.Department_ID)}
//       placeholder="Select User Type"
//       isClearable
// onChange={(selected) => {
//   if (selected) {
//     SelectedRole(selected.Department_ID);
 
//     setFormData((prev) => ({
//       ...prev,
//       Department_Name: selected.Department_Name,
//       Department_ID: selected.Department_ID,
//     }));
//   } else {
//     SelectedRole(null);
 
//     setFormData((prev) => ({
//       ...prev,
//       Department_Name: "",
//       Department_ID: "",
//       Role: "",
//       RoleID: "",
//     }));
//   }
// }}
//       styles={{
//         control: (base) => ({
//           ...base,
//           minHeight: "40px",
//           height: "40px",
//           border: "1px solid #cfcfcf",
//           borderRadius: "6px",
//           boxShadow: "none",
//           fontSize: "14px",
//         }),
//         valueContainer: (base) => ({
//           ...base,
//           height: "40px",
//           padding: "0 12px",
//         }),
//         indicatorsContainer: (base) => ({
//           ...base,
//           height: "40px",
//         }),
//       }}
//     />
 
//                 </div>

//                 <div style={{ width:"100%"}}>
//                   <label className="form-label" style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}}>
//                     Role
//                   </label>
//                   {/* <select
//                     className="form-control"
//                     id="Role"
//                     onChange={handleChange}
//                   >
//                     <option value={false}>Selected Role</option>
//                     {Role.map((e) => {
//                       if (optionrole === e.Department_ID) {
//                         return (
//                           <option key={e.RoleID} value={JSON.stringify(e)}>
//                             {e.Designation}
//                           </option>
//                         );
//                       }
//                     })}
//                   </select> */}
//                   <Select
//       options={Role.filter(
//         (e) => optionrole === e.Department_ID
//       )}
//       getOptionLabel={(e) => e.Designation}
//       getOptionValue={(e) => String(e.RoleID)}
//       placeholder="Select Role"
//       isClearable
//        onChange={(selected) => {
//     if (selected) {
//       setFormData((prev) => ({
//         ...prev,
//         Role: selected.Designation,
//         RoleID: selected.RoleID,
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         Role: "",
//         RoleID: "",
//       }));
//     }
//   }}
//       styles={{
//         control: (base) => ({
//           ...base,
//           minHeight: "40px",
//           height: "40px",
//           border: "1px solid #cfcfcf",
//           borderRadius: "6px",
//           boxShadow: "none",
//           fontSize: "14px",
//         }),
//         valueContainer: (base) => ({
//           ...base,
//           height: "40px",
//           padding: "0 12px",
//         }),
//         indicatorsContainer: (base) => ({
//           ...base,
//           height: "40px",
//         }),
//       }}
//     />
 
//                 </div>

//               </div>

// {formData.Department_Name === "State Checker" && (
//   <div style={{ width: "50%", marginBottom: "18px", marginTop: "20px" }}>
//     <label
//       className="form-label"
//       style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "black", marginBottom: "6px" }}
//     >
//       Select State Maker
//     </label>
//     <select
//       className="form-control"
//       name="MakerUsername"
//       value={formData.MakerUsername}
//       onChange={handleChange}
//       required
//     >
//       <option value="">Select State Maker</option>
//       {StateMakers.map((m) => (
//         <option key={m.ID} value={m.Username}>
//           {m.FullName}
//         </option>
//       ))}
//     </select>
//   </div>
// )}


//               {/* <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className="form-label" style={{ fontWeight: '700' }}>Password</label>
//                 <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
//                   <input type="password" className="form-control" name="Password" value={formData.Password} onChange={handleChange} placeholder="Enter Password Here" />
//                   <i style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: '10px', cursor: 'pointer' }} className="fa-regular fa-eye" onClick={(e) => PasswordManager(e)}></i>
//                 </div>
//               </div>
//             </div> */}

//               <div
//                 style={{
//                   display: "flex",
//                   gap: "20px",
//                   justifyContent: "space-evenly",
//                 }}
//               >
//                 {/* <div style={{ display: "grid" }} className="col-5">
//                   <label className="form-label" style={{ fontWeight: "700" }}>
//                     Password
//                   </label>
//                   <div style={{ position: "relative", display: "flex" }}>
//                     <input
//                       type="password"
//                       className="form-control"
//                       name="Password"
//                       value={formData.Password}
//                       onChange={handleChange}
//                       placeholder="Enter Password Here"
//                       style={{ paddingRight: "40px" }}
//                     />
//                     <i
//                       className={
//                         showPassword ? "fa-regular fa-eye" : "fa-regular fa-eye"
//                       }
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         position: "absolute",
//                         right: "10px",
//                         cursor: "pointer",
//                         transform: "translate(-70%)",
//                       }}
//                       className="fa-regular fa-eye"
//                       onClick={(e) => PasswordManager(e)}
//                     ></i>
//                   </div>
//                 </div> */}
//                 <div style={{width:"50%",marginBottom:"18px",     marginTop: "20px",}}>
//                   <label  style={{ display: "block",fontSize: "14px",fontWeight: "700",color:"black", marginBottom: "6px",}} > Password </label>
//                 <div
//                   // className="form-control"
//                   style={{
//                     // display: "flex",
//                     position: "relative",
//                     width: "100%",
//                     // border: "1px solid #e6d6d6",
               
//                   }}
//                 >
//                   <input
//                     className="form-control custom-password-input"
//                     required
//                     type={showPassword ? "text" : "password"}
//                     name="Password"
//                     value={formData.Password}
//                     onChange={handleChange}
//                     placeholder="Enter Password Here"
//                     style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} 
//                   />

//                   {/* EYE ICON - ONLY THIS PART CHANGE */}
//                   <div
//                     onClick={() => setShowPassword(!showPassword)}
//                     style={{
//                       position: "absolute",
//                       right: "12px",
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       width: "20px",
//                       height: "20px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <svg
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                       style={{
//                         display: "block",
//                         width: "20px",
//                         height: "20px",
//                       }}
//                     >
//                       {/* Eye */}
//                       <path
//                         d="M2 12C2 12 5.5 5 12 5C18.5 5 22 12 22 12C22 12 18.5 19 12 19C5.5 19 2 12 2 12Z"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />

//                       {/* Eye pupil */}
//                       <circle
//                         cx="12"
//                         cy="12"
//                         r="3"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                       />

//                       {/* Slash */}
//                       <line
//                         x1="4"
//                         y1="4"
//                         x2="20"
//                         y2="20"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         style={{
//                           opacity: showPassword ? 0 : 1,
//                         }}
//                       />
//                     </svg>
//                   </div>
//                 </div>
//               </div>
// </div>

//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   gap: "10px",
//                   padding: "2.5rem",
//                 }}
//               >
//                 <button
//                   type="submit"
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     //30/10
//                     borderRadius: "20px",
//                     width: "7rem",
//                     height: "2.5rem",
//                     backgroundColor: "rgb(57, 181, 74)",
//                     border: "none",
//                     fontSize: "17px",
//                     gap: "4px",
//                   }}
//                 >
//                   {/* <img src={submit} style={{ width: "1.2rem" }} /> Submit */}
//                   {/* 28-09 add loader */}
//                    {loading ? (
//     <>
//       <span
//         style={{
//           width: "16px",
//           height: "16px",
//           border: "2px solid rgba(255,255,255,0.4)",
//           borderTop: "2px solid #fff",
//           borderRadius: "50%",
//           animation: "spin 0.7s linear infinite",
//           display: "inline-block",
//         }}
//       ></span>
//       Saving...
//     </>
//   ) : (
//     <>
//       <img src={submit} style={{ width: "1.2rem" }} />
//       Submit
//     </>
//   )}
               
//                 </button>

//                 <button
//                   onClick={resetData}
//                   type="button"
//                    style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     //30/10
//                     borderRadius: "20px",
//                     width: "7rem",
//                     height: "2.5rem",
//                     backgroundColor: "red",
//                     border: "none",
//                     fontSize: "17px",
//                     gap: "4px",
//                   }}
//                 >
//                   <img src={Cancel32} style={{ width: "1.2rem" }} /> Cancel
//                 </button>
//               </div>
//             </div>
//           </Form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateEmployee;













import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import Function from "../../../StateContext/Application";
import {
  Cancel32,
  Email32,
  PhoneNumber32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import Select from "react-select";
 
const CreateEmployee = () => {
  const types = useContext(Function);
  const { EmployeeManagement, Roles, DepartmentHandler } = types;
  const [EmployeeList, SetEmployeeList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [emailError, setEmailError] = useState(""); //28-09
     const [errors, setErrors] = useState({});//21-10
 
  const [formData, setFormData] = useState({
    FullName: "",
    ProfilePic: "",
    PhoneNumber: "",
    Email: "",
    Password: "",
    RoleID: "",
    Role: "",
    Department_ID: "",
    Department_Name: "",
    Username: "",
        MakerUsername: "", //28-09

  });

  const [Role, SetRole] = useState([]);
  const [optionrole, SelectedRole] = useState();
  const [DepartmentList, SetDepartment] = useState([]);
  const [FilteredDepartment, SetFilteredDepartment] = useState([]);
  const formdataref = useRef(null);
    const [StateMakers, SetStateMakers] = useState([]);//28-09
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    getData();
  }, []);
  // const getData = async () => {
  //   try {
  //     let data = await Roles("View", null);
  //     SetRole(data);
  //     let department = await DepartmentHandler("view", null, null);
  //     SetDepartment(department);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const getData = async () => {
    try {
      let data = await Roles("View", null);
      SetRole(data);
      let department = await DepartmentHandler("view", null, null);
      console.log("ALL DEPARTMENT =>", department);

      let user =
        JSON.parse(localStorage.getItem("User")) ||
        JSON.parse(localStorage.getItem("user"));
      console.log("LOGIN USER =>", user);
      // let filteredDepartment = [];

      //     const role = user?.Role?.trim();
      // const dept = user?.Department_Name?.trim();
      // console.log(role)
      // console.log(dept)
      // if (role?.includes("state")) {
      //   filteredDepartment = department.filter(
      //     e =>
      //       e.Department_Name === "State Maker" ||
      //       e.Department_Name === "State Checker"
      //   );
      // } else if (role?.includes("agency admin")) {
      //   filteredDepartment = department.filter(
      //     e =>
      //       e.Department_Name === "Agency Maker" ||
      //       e.Department_Name === "Agency Checker"
      //   );
      // } else if (role?.includes("New Agency Admin")) {
      //   filteredDepartment = department.filter(

      //     e =>
      //       e.Department_Name === "New Agency Maker" ||
      //       e.Department_Name === "New Agency Checker"
      //   );
      //   console.log(filteredDepartment)
      // }
      // else if (
      //   dept === "agency maker" ||
      //   dept === "agency checker"
      // ) {
      //   filteredDepartment = department.filter(
      //     e =>
      //       e.Department_Name === "New Agency Maker" ||
      //       e.Department_Name === "New Agency Checker"
      //   );
      // }

      //       console.log("FILTERED DEPARTMENT =>", filteredDepartment);

      //       SetDepartment(filteredDepartment);
      const role = user?.Role?.trim().toLowerCase();
      const dept = user?.Department_Name?.trim().toLowerCase();

      let filteredDepartment = [];

      // if (role.includes("state")) {
      //   filteredDepartment = department.filter(
      //     (e) =>
      //       e.Department_Name === "State Maker" ||
      //       e.Department_Name === "State Checker",
      //   );
      // } else if (role.includes("agency admin")) {
      //   filteredDepartment = department.filter(
      //     (e) =>
      //       e.Department_Name === "Agency Maker" ||
      //       e.Department_Name === "Agency Checker",
      //   );
      // } else if (role.includes("new agency admin")) {
      //   filteredDepartment = department.filter(
      //     (e) =>
      //       e.Department_Name === "New Agency Maker" ||
      //       e.Department_Name === "New Agency Checker",
      //   );
      // } else if (dept === "agency maker" || dept === "agency checker") {
      //   filteredDepartment = department.filter(
      //     (e) =>
      //       e.Department_Name === "New Agency Maker" ||
      //       e.Department_Name === "New Agency Checker",
      //   );
      // } else {
      //   // fallback
      //   filteredDepartment = department;
      // }


      // 22-09 depart fetch change for user type
      if (role.includes("state")) {
  filteredDepartment = department.filter(
    (e) =>
      e.Department_Name === "State Maker" ||
      e.Department_Name === "State Checker",
  );
} else if (role.includes("new agency admin")) {   // ← moved up
  filteredDepartment = department.filter(
    (e) =>
      e.Department_Name === "New Agency Maker" ||
      e.Department_Name === "New Agency Checker",
  );
} else if (role.includes("agency admin")) {        // ← moved down
  filteredDepartment = department.filter(
    (e) =>
      e.Department_Name === "Agency Maker" ||
      e.Department_Name === "Agency Checker",
  );
} else if (dept === "agency maker" || dept === "agency checker") {
  filteredDepartment = department.filter(
    (e) =>
      e.Department_Name === "New Agency Maker" ||
      e.Department_Name === "New Agency Checker",
  );
} else {
  filteredDepartment = department;
}

      SetDepartment(filteredDepartment);
      console.log("LOGIN USER =>", user);
      console.log("ROLE =>", user?.Role);
      console.log("DEPARTMENT =>", user?.Department_Name);
      console.log("ALL DEPARTMENT =>", department);
      console.log("FILTERED DEPARTMENT =>", filteredDepartment);
      let employees = await EmployeeManagement("View", null);
 // 28-09
      const empList = employees || [];
SetEmployeeList(empList);
SetStateMakers(
  empList.filter((emp) => emp.Department_Name === "State Maker")
);
      // SetEmployeeList(employees || []);
    } catch (error) {
      console.error("Get Data Error =>", error);
    }
  };

  const isEmailTaken = (email) =>
    EmployeeList.some(
      (emp) => emp.Email?.trim().toLowerCase() === email.trim().toLowerCase(),
    );

     // 23-09
  const isUsernameTaken = (username) =>
    EmployeeList.some(
      (emp) => emp.Username?.trim().toLowerCase() === username.trim().toLowerCase(),
    );

  const handleChange = async (e) => {
    try {
      if (e.target.id === "Department_Name") {
        let obj = JSON.parse(e.target.value);
        SelectedRole(obj.Department_ID);
        formData.Department_Name = obj.Department_Name;
        formData.Department_ID = obj.Department_ID;
           // 28-09
         if (obj.Department_Name !== "State Checker") {
    formData.MakerUsername = "";
  }
      } else if (e.target.id === "Role") {
        let obj = JSON.parse(e.target.value);
        formData.Role = obj.Designation;
        formData.RoleID = obj.RoleID;
      }
      
      // else {
      //   const { name, value } = e.target;
      //   setFormData({ ...formData, [name]: value });
      // }
      // 28-09
       else {
  const { name, value } = e.target;

  // 21-10
  setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
        // -----------
 
  if (name === "Email") {
    setFormData({ ...formData, Email: value });
 
    // Correct email format check
     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
    if (value.length > 0 && !emailRegex.test(value)) {
      setEmailError("Please enter a correct email address.");
      return;
    }
 
    // Duplicate email check
    if (value.length > 0 && isEmailTaken(value)) {
      setEmailError("This email is already in use.");
      alert("This email is already in use.");
      return;
    }
 
    setEmailError("");
  } else {
    setFormData({ ...formData, [name]: value });
  }
}



      
    } catch (error) {
      console.error(error);
    }
  };

//   const Submit = async (e) => {
//     e.preventDefault();
//     try {
//       if (isEmailTaken(formData.Email)) {
//         alert(
//           "This email is already registered. Please use a different email.",
//         );
//         return;
//       }
//       // let data = await EmployeeManagement("Create", formData);
//       // if (data === true) {
//       //   alert("Employee Created Successfully");
//       //   window.location.reload();
//       // } else {
//       //   alert("Employee Not Created");
//       //   window.location.reload();
//       // }
//        // 23-09
//       let data = await EmployeeManagement("Create", formData);
// if (data === true) {
//   alert("Employee Created Successfully");
//   window.location.reload();
// } else {
//   alert("Employee Not Created");
//   window.location.reload();
// }
//     } catch (error) {
//       console.error(error);
//     }
//   };

// 23-09
//   const Submit = async (e) => {
//     e.preventDefault();
//     setLoading(true);//28-09
//     try {
//       if (isEmailTaken(formData.Email)) {
//         alert(
//           "This email is already registered. Please use a different email.",
//         );
//         return;
//       }

//       // 23-09 — added username duplicate check alongside the email one
//       if (isUsernameTaken(formData.Username)) {
//         alert(
//           "This username is already taken. Please choose a different username.",
//         );
//         return;
//       }

//       // let data = await EmployeeManagement("Create", formData);

//       // Backend returns { success, message } — not a plain boolean —
//       // so it can tell us *which* field collided (email or username).
//       // if (data?.success) {
//       //   alert("Employee Created Successfully");
//       //   window.location.reload();
//       // } else {
//       //   alert(data?.message || "Employee Not Created");
//       // }


//       let data = await EmployeeManagement("Create", formData);

// if (data === true) {
//   alert("Employee Created Successfully");
//   window.location.reload();
// } else {
//   alert("Employee Not Created");
// }
//     } catch (error) {
//       console.error(error);
//     }
//     // 28-09
//      finally {
//     // Loader stop
//     setLoading(false);
//   }



//   };



// 05-10 chnage for validation to all filed
// const Submit = async (e) => {
//   e.preventDefault();

//   // Validate all mandatory fields
//   if (!formData.FullName?.trim()) {
//     alert("Please enter Full Name.");
//     return;
//   }

//   if (!formData.PhoneNumber?.trim()) {
//     alert("Please enter Phone Number.");
//     return;
//   }

//   if (formData.PhoneNumber.length !== 10) {
//     alert("Phone Number must be 10 digits.");
//     return;
//   }

//   if (!formData.Email?.trim()) {
//     alert("Please enter Email.");
//     return;
//   }

//   if (emailError) {
//     alert("Please enter a valid Email address.");
//     return;
//   }

//   if (!formData.Username?.trim()) {
//     alert("Please enter Username.");
//     return;
//   }

//   if (!formData.Password?.trim()) {
//     alert("Please enter Password.");
//     return;
//   }

//   if (!formData.Department_ID) {
//     alert("Please select User Type.");
//     return;
//   }

//   if (!formData.RoleID) {
//     alert("Please select Role.");
//     return;
//   }

//   // State Maker is mandatory only for State Checker
//   if (
//     formData.Department_Name === "State Checker" &&
//     !formData.MakerUsername
//   ) {
//     alert("Please select State Maker.");
//     return;
//   }

//   // Duplicate email check
//   if (isEmailTaken(formData.Email)) {
//     alert(
//       "This email is already registered. Please use a different email."
//     );
//     return;
//   }

//   // Duplicate username check
//   if (isUsernameTaken(formData.Username)) {
//     alert(
//       "This username is already taken. Please choose a different username."
//     );
//     return;
//   }

//   setLoading(true);

//   try {
//     const data = await EmployeeManagement("Create", formData);

//     if (data === true) {
//       alert("Employee Created Successfully");
//       window.location.reload();
//     } else {
//       alert("Employee Not Created");
//     }
//   } catch (error) {
//     console.error("Create Employee Error:", error);
//     alert("Something went wrong while creating the employee.");
//   } finally {
//     setLoading(false);
//   }
// };

// // 01/10 for alert
// const Submit = async (e) => {
//   e.preventDefault();

//   if (loading) return;

//   setLoading(true);

//   try {
//     if (isEmailTaken(formData.Email)) {
//       alert(
//         "This email is already registered. Please use a different email."
//       );
//       return;
//     }

//     if (isUsernameTaken(formData.Username)) {
//       alert(
//         "This username is already taken. Please choose a different username."
//       );
//       return;
//     }

//     const data = await EmployeeManagement("Create", formData);

//     console.log("Create Employee Response:", data);

//     if (data?.success === true) {
//       alert(data.message || "Employee Created Successfully");
//       window.location.reload();
//     } else {
//       alert(data?.message || "Employee  Created"); //temporay
//     }

//   } catch (error) {
//     console.error("Create Employee Error:", error);
//     alert("Something went wrong while creating the employee.");
//   } finally {
//     setLoading(false);
//   }
// };
  

// 21-10 
 const Submit = async (e) => {
    e.preventDefault();
 
    const newErrors = {};
 
    if (!formData.FullName?.trim()) {
      newErrors.FullName = "Full Name is required";
    }
 
    if (!formData.PhoneNumber?.trim()) {
      newErrors.PhoneNumber = "Phone Number is required";
    } else if (formData.PhoneNumber.length !== 10) {
      newErrors.PhoneNumber = "Enter a valid 10-digit phone number";
    }
 
    if (!formData.Email?.trim()) {
      newErrors.Email = "Email is required";
    }
 
    if (!formData.Username?.trim()) {
      newErrors.Username = "Username is required";
    }
 
    if (!formData.Department_ID || !formData.Department_Name) {
      newErrors.Department_Name = "Please select User Type";
    }
 
    if (!formData.RoleID || !formData.Role) {
      newErrors.Role = "Please select Role";
    }
 
    if (!formData.Password?.trim()) {
      newErrors.Password = "Password is required";
    }
 
    if (
      formData.Department_Name === "State Checker" &&
      !formData.MakerUsername
    ) {
      newErrors.MakerUsername = "Please select State Maker";
    }
 
    setErrors(newErrors);
 
    if (Object.keys(newErrors).length > 0) {
      return;
    }
 
    setLoading(true);
 
    try {
      if (isEmailTaken(formData.Email)) {
        setErrors({
          Email: "This email is already registered",
        });
        return;
      }
 
      if (isUsernameTaken(formData.Username)) {
        setErrors({
          Username: "This username is already taken",
        });
        return;
      }
 
      const data = await EmployeeManagement("Create", formData);
 
      if (data === true) {
        alert("Employee Created Successfully");
        window.location.reload();
      } else {
        alert("Employee Not Created");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
 

function PasswordManager(e) {
    let input = e.currentTarget.parentNode.children[0];
    let eye = e.currentTarget.parentNode.children[1];
    input.type === "password"
      ? (input.type = "text")
      : (input.type = "password");

    eye.className === "fa-regular fa-eye"
      ? (eye.className = "fa-regular fa-eye-slash")
      : (eye.className = "fa-regular fa-eye");
  }
  const resetData = () => {
    formdataref.current.reset();
    setFormData([]);
  };
 
  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "white",
        maxLength: "95vh",
        minHeight: "95vh",
        maxHeight: "95vh",
        overflowY: "auto",
        marginTop:"10px"
      }}
    >
      <div>
        {/* 29-09 add img */}
         <h5 style={{fontSize:"22px", fontWeight:"700", marginLeft:'30px'}} ><img
    src="/Create-Employee-32.png"
    alt="img"
   style={{height:"28px", width:"28px"}}
  />
      Create User</h5>
        <div>
          {/* //30/10 */}
          <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "930px", margin: "0 auto" }}>
          <Form
            onSubmit={Submit} 
            ref={formdataref} 
            noValidate
            //30/10
           style={{
  backgroundColor: "#EEF1F6",
  borderRadius: "10px",
  padding: "25px 28px",
}}
          >
            {/* //30/10 */}
            <div style={{ width: "100%" }}>
             

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr",columnGap: "25px", marginBottom: "18px", }}>
                <div style={{ width:"100%"}}>
                  <label className="form-label"  style={{ display: "block",fontSize: "13px",fontWeight: "500",color:"black", marginBottom: "6px",}}>  Full Name </label>
                  <input
                    type="text"
                    className="form-control"
                    name="FullName"
                    value={formData.FullName}
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   if (/^[A-Za-z\s]*$/.test(value)) {
                    //     handleChange(e);
                    //   }
                    // }}
                    // 05-10 for validation
                    onChange={(e) => {
  // const value = e.target.value;

  // if (/^[A-Za-z\s]*$/.test(value)) {
  //   handleChange(e);
  // }

  // 21-10
   const value = e.target.value;
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        handleChange(e);
                      }
 
}}
                    required
                    placeholder="Enter Full Name Here"
                      style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} />
                      {errors.FullName && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {errors.FullName}
                    </span>
                  )}
                </div>

                <div style={{ width:"100%"}}>
                  <label className="form-label" style={{ display: "block",fontSize: "13px",fontWeight: "500",color:"black", marginBottom: "6px",}}>
                    Phone Number
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    {/* <input
                      type="tel"
                      pattern="\d{10}"
                      minLength="10"
                      maxLength="10"
                      className="form-control"
                      name="PhoneNumber"
                      value={formData.PhoneNumber}
                      onChange={handleChange}
                      placeholder="Enter Phone Number Here"
                      style={{ paddingRight: "35px" }}
                    /> */}
                    <input
                      type="tel"
                      className="form-control"
                      name="PhoneNumber"
                      value={formData.PhoneNumber}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 12);
                        handleChange({
                          target: {
                            name: "PhoneNumber",
                            value,
                          },
                        });
                      }}
                      placeholder="Enter Phone Number Here"
                      maxLength={10}
                      inputMode="numeric"
                      style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }}                     />
                      
                    
 
                    <img
                      src={PhoneNumber32}
                      alt="Phone Icon"
                      style={{
                        position: "absolute",
                        right: "10px",
                        width: "20px",
                        height: "20px",
                      }}
                    />

                  </div>
                      {errors.PhoneNumber && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {errors.PhoneNumber}
                    </span>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:"1fr 1fr",
                  columnGap: "25px",
                  marginBottom:"18px"
                  // justifyContent: "space-evenly",
                }}
              >
                <div style={{ width:"100%"}}>
                  <label className="form-label" style={{ display: "block",fontSize: "13px",fontWeight: "500",color:"black", marginBottom: "6px",}}>
                    Email
                  </label>
                  <div
                    style={{
                      // display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <input
                      type="email"
                      className="form-control"
                      name="Email"
                      value={formData.Email}
                      onChange={handleChange}
                      required
                      // onBlur={(e) => {
                      //   if (isEmailTaken(e.target.value)) {
                      //     alert("This email is already in use.");
                      //   }
                      // }}
                      placeholder="Enter Email Here"
                      style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} 
                    />
       
         {errors.Email && (
                      <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                        {errors.Email}
                      </span>
                    )}
 
                 
 
                    <img
                      src={Email32}
                      style={{
                        position: "absolute",
                        right: "10px",
                        width: "20px",
                        height: "20px",
                        top:"10px"
                      }}
                    />
                                    {/* 28-09 */}
                    {emailError && (
<span

    style={{

      color: "red",

      fontSize: "13px",

      marginTop: "5px",

    }}
>

    {emailError}
</span>

)}
                    
                  </div>
                </div>

                <div style={{ width:"100%"}}>
                  <label className="form-label" style={{ display: "block",fontSize: "13px",fontWeight: "500",color:"black", marginBottom: "6px",}}>
                    Username
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="Username"
                    value={formData.Username}
                    onChange={handleChange}
                    required
                    placeholder="Enter Username Here"
                    style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} 
                  />
                    {errors.Username && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {errors.Username}
                    </span>
                  )}
 
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "space-evenly",
                }}
              >
                <div style={{ width:"100%"}}>
                  <label className="form-label" style={{ display: "block",fontSize: "13px",fontWeight: "500",color:"black", marginBottom: "6px",}}>
                    User Type
                  </label>
                  {/* <select
                    className="form-control"
                    id="Department_Name"
                    onChange={handleChange}
                  >
                    <option value={false}>Select User Type</option>
                    {DepartmentList.map((e) => (
                      <option key={e.Department_ID} value={JSON.stringify(e)}>
                        {e.Department_Name}
                      </option>
                    ))}
                  </select> */}
                  <Select
      options={DepartmentList}
      getOptionLabel={(e) => e.Department_Name}
      getOptionValue={(e) => String(e.Department_ID)}
      placeholder="Select User Type"
      isClearable
onChange={(selected) => {
  if (selected) {
    SelectedRole(selected.Department_ID);
 
    setFormData((prev) => ({
      ...prev,
      Department_Name: selected.Department_Name,
      Department_ID: selected.Department_ID,
    }));
  } else {
    SelectedRole(null);
 
    setFormData((prev) => ({
      ...prev,
      Department_Name: "",
      Department_ID: "",
      Role: "",
      RoleID: "",
    }));
  }
}}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "40px",
          height: "40px",
          border: "1px solid #cfcfcf",
          borderRadius: "6px",
          boxShadow: "none",
          fontSize: "14px",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "40px",
          padding: "0 12px",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "40px",
        }),
      }}
    />
    {errors.Department_Name && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {errors.Department_Name}
                    </span>
                  )}
 
 
                </div>

                <div style={{ width:"100%"}}>
                  <label className="form-label" style={{ display: "block",fontSize: "13px",fontWeight: "500",color:"black", marginBottom: "6px",}}>
                    Role
                  </label>
                  {/* <select
                    className="form-control"
                    id="Role"
                    onChange={handleChange}
                  >
                    <option value={false}>Selected Role</option>
                    {Role.map((e) => {
                      if (optionrole === e.Department_ID) {
                        return (
                          <option key={e.RoleID} value={JSON.stringify(e)}>
                            {e.Designation}
                          </option>
                        );
                      }
                    })}
                  </select> */}
                  <Select
      options={Role.filter(
        (e) => optionrole === e.Department_ID
      )}
      getOptionLabel={(e) => e.Designation}
      getOptionValue={(e) => String(e.RoleID)}
      placeholder="Select Role"
      isClearable
       onChange={(selected) => {
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        Role: selected.Designation,
        RoleID: selected.RoleID,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        Role: "",
        RoleID: "",
      }));
    }
  }}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "40px",
          height: "40px",
          border: "1px solid #cfcfcf",
          borderRadius: "6px",
          boxShadow: "none",
          fontSize: "14px",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "40px",
          padding: "0 12px",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "40px",
        }),
      }}
    />
     {errors.Role && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {errors.Role}
                    </span>
                  )}
 
                </div>

              </div>

{formData.Department_Name === "State Checker" && (
  <div style={{ width: "50%", marginBottom: "18px", marginTop: "20px" }}>
    <label
      className="form-label"
      style={{ display: "block", fontSize: "13px", fontWeight: "500", color: "black", marginBottom: "6px" }}
    >
      Select State Maker
    </label>
    <select
      className="form-control"
      name="MakerUsername"
      value={formData.MakerUsername}
      onChange={handleChange}
      required
    >
      <option value="">Select State Maker</option>
      {StateMakers.map((m) => (
        <option key={m.ID} value={m.Username}>
          {m.FullName}
        </option>
      ))}
    </select>

      {errors.Department_Name && (
                    <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {errors.Department_Name}
                    </span>
                  )}
 
  </div>
)}


              {/* <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'grid' }} className="col-5">
                <label className="form-label" style={{ fontWeight: '700' }}>Password</label>
                <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                  <input type="password" className="form-control" name="Password" value={formData.Password} onChange={handleChange} placeholder="Enter Password Here" />
                  <i style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: '10px', cursor: 'pointer' }} className="fa-regular fa-eye" onClick={(e) => PasswordManager(e)}></i>
                </div>
              </div>
            </div> */}

              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "space-evenly",
                }}
              >
                {/* <div style={{ display: "grid" }} className="col-5">
                  <label className="form-label" style={{ fontWeight: "700" }}>
                    Password
                  </label>
                  <div style={{ position: "relative", display: "flex" }}>
                    <input
                      type="password"
                      className="form-control"
                      name="Password"
                      value={formData.Password}
                      onChange={handleChange}
                      placeholder="Enter Password Here"
                      style={{ paddingRight: "40px" }}
                    />
                    <i
                      className={
                        showPassword ? "fa-regular fa-eye" : "fa-regular fa-eye"
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        right: "10px",
                        cursor: "pointer",
                        transform: "translate(-70%)",
                      }}
                      className="fa-regular fa-eye"
                      onClick={(e) => PasswordManager(e)}
                    ></i>
                  </div>
                </div> */}
                <div style={{width:"50%",marginBottom:"18px",     marginTop: "20px",}}>
                  <label  style={{  display: "block", fontSize: "13px", fontWeight: "500",  color: "#333", marginBottom: "6px", }} > Password </label>
                <div
                  // className="form-control"
                  style={{
                    // display: "flex",
                    position: "relative",
                    width: "100%",
                    // border: "1px solid #e6d6d6",
               
                  }}
                >
                  <input
                    className="form-control custom-password-input"
                    required
                    type={showPassword ? "text" : "password"}
                    name="Password"
                    value={formData.Password}
                    onChange={handleChange}
                    placeholder="Enter Password Here"
                    style={{ width: "100%", height: "40px", padding: "8px 14px", fontSize: "13px",  color: "#333", backgroundColor: "#ffffff",border: "1px solid #cfcfcf", borderRadius: "6px", outline: "none",  boxShadow: "none", }} 
                  />

 {errors.Password && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors.Password}
                      </span>
                    )}
                  {/* EYE ICON - ONLY THIS PART CHANGE */}
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        display: "block",
                        width: "20px",
                        height: "20px",
                      }}
                    >
                      {/* Eye */}
                      <path
                        d="M2 12C2 12 5.5 5 12 5C18.5 5 22 12 22 12C22 12 18.5 19 12 19C5.5 19 2 12 2 12Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />

                      {/* Eye pupil */}
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="currentColor"
                        strokeWidth="2"
                      />

                      {/* Slash */}
                      <line
                        x1="4"
                        y1="4"
                        x2="20"
                        y2="20"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        style={{
                          opacity: showPassword ? 0 : 1,
                        }}
                      />
                    </svg>
                  </div>
                </div>
              </div>
</div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "2.5rem",
                }}
              >
                <button
                  type="submit"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //30/10
                    borderRadius: "20px",
                    width: "7rem",
                    height: "2.5rem",
                    backgroundColor: "rgb(57, 181, 74)",
                    border: "none",
                    fontSize: "17px",
                    gap: "4px",
                  }}
                >
                  {/* <img src={submit} style={{ width: "1.2rem" }} /> Submit */}
                  {/* 28-09 add loader */}
                   {loading ? (
    <>
      <span
        style={{
          width: "16px",
          height: "16px",
          border: "2px solid rgba(255,255,255,0.4)",
          borderTop: "2px solid #fff",
          borderRadius: "50%",
          animation: "spin 0.7s linear infinite",
          display: "inline-block",
        }}
      ></span>
      Saving...
    </>
  ) : (
    <>
      <img src={submit} style={{ width: "1.2rem" }} />
      Submit
    </>
  )}
               
                </button>

                <button
                  onClick={resetData}
                  type="button"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //30/10
                    borderRadius: "20px",
                    width: "7rem",
                    height: "2.5rem",
                    backgroundColor: "red",
                    border: "none",
                    fontSize: "17px",
                    gap: "4px",
                  }}
                >
                  <img src={Cancel32} style={{ width: "1.2rem" }} /> Cancel
                </button>
              </div>
            </div>
        
          </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEmployee;
